export enum ViewPlantByRegionEnum {
  All = 1,
  OnlyQaQi = 2,
  OnlyQp = 3,
}
